import styled from 'styled-components';
import { media } from 'helpers/breakpoints';

import { InfoTitle } from 'components/Toolkit/InfoTitle/InfoTitle';
import { ModalButtonGroup } from 'components/Toolkit/Modal/BaseModal';

export const Header = styled(InfoTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

export const SModalButtonGroup = styled(ModalButtonGroup)`
  position: fixed;
  bottom: 0;
  right: ${({ theme }) => theme.spacing.M24};
  left: ${({ theme }) => theme.spacing.M24};
  background-color: ${({ theme }) => theme.colors.WHITE};
  height: 64px;
  padding: ${({ theme }) => `${theme.spacing.S8} ${theme.spacing.M24}`};
  margin: ${({ theme }) => `0 -${theme.spacing.M24}`};

  ${media.medium} {
    position: sticky;
    padding: ${({ theme }) =>
      `${theme.spacing.S4} ${theme.spacing.M24} ${theme.spacing.M24}`};
  }
`;

export const Disclaimer = styled.p`
  ${({ theme }) => theme.fontSize.B12};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export const ShowInterestHeader = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export const CheckboxGrid = styled.div`
  ${media.medium} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: ${({ theme }) => theme.spacing.M16};
  }
`;

export const Content = styled.div`
  width: 100%;

  ${media.medium} {
    width: 544px;
  }
`;
